import { Component, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { GetCodeStepModalComponent } from '../get-code-step-modal/get-code-step-modal.component';
import { RefreshPlatformVerificationCodeModalComponent } from '../refresh-platform-verification-code-modal/refresh-platform-verification-code-modal.component';
import { TipPlatformVerificationCodeModalComponent } from '../tip-platform-verification-code-modal/tip-platform-verification-code-modal.component';
import { OrderApiService } from 'src/app/services/api/order-api.service';

@Component({
  selector: 'app-verification-code-panel',
  templateUrl: './verification-code-panel.component.html',
  styleUrls: ['./verification-code-panel.component.scss'],
})
export class VerificationCodePanelComponent {
  @Input() data: any;

  constructor(private dialog: MatDialog, private api: OrderApiService) {}
  openCodeModal(data: any) {
    this.timeout = 91;
    this.dialog
      .open(GetCodeStepModalComponent, { width: '726px' })
      .afterClosed()
      .subscribe((r) => {
        if (r) this.getLink(data);
      });
  }

  link: any;
  timeout = 91;
  async getLink(data: any) {
    try {
      this.timeout -= 1;
      await this.api.getLink(data.id, 'netflix');
      if (this.timeout > 0) {
        let interval = setInterval(async () => {
          this.timeout -= 1;
          const r = await this.api.getSelectLink(data.id, 'netflix');
          if (r.data) {
            this.link = r.data;
            clearInterval(interval);
          }
          if (this.timeout === 0) {
            clearInterval(interval);
          }
        }, 1000);
      }
    } catch (error) {}
  }

  refresh(data: any) {
    this.timeout = 91;
    this.dialog
      .open(RefreshPlatformVerificationCodeModalComponent, { width: '726px' })
      .afterClosed()
      .subscribe((r) => {
        if (r) {
          this.getLink(data);
        }
      });
  }

  openTipModal(data: any) {
    this.timeout = 91;
    this.dialog
      .open(TipPlatformVerificationCodeModalComponent, { width: '726px' })
      .afterClosed()
      .subscribe((r) => {
        if (r) {
          this.getLink(data);
        }
      });
  }

  openLink() {
    window.open(this.link);
  }
}
